import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthenticationService } from '../services/authentication.service';
import { NavUserAccessService } from '../services/nav-user-access.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { trigger, transition, group, query, style, animate } from '@angular/animations';
import { OktaAuthService } from '@okta/okta-angular';
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-pra-main',
  templateUrl: './pra-main.component.html',
  styleUrls: ['./pra-main.component.css'],
  animations: [
    trigger('routeAnimation', [
      transition('1 => 2', [
        style({ height: '!' }),
        query(':enter', style({ transform: 'translateX(100%)' })),
        query(':enter, :leave', style({ position: 'absolute', top: 0, left: 0, right: 0 })),
        // animate the leave page away
        group([
          query(':leave', [
            animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(-100%)' })),
          ]),
          // and now reveal the enter
          query(':enter', animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(0)' }))),
        ]),
      ]),
      transition('3 => 2, 2 => 1', [
        style({ height: '!' }),
        query(':enter', style({ transform: 'translateX(-100%)' })),
        query(':enter, :leave', style({ position: 'absolute', top: 0, left: 0, right: 0 })),
        // animate the leave page away
        group([
          query(':leave', [
            animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(100%)' })),
          ]),
          // and now reveal the enter
          query(':enter', animate('0.3s cubic-bezier(.35,0,.25,1)', style({ transform: 'translateX(0)' }))),
        ]),
      ]),
    ])
  ]
})
export class PraMainComponent {

  //Current User
  currentUser: any;

  //Okta variables
  isAuthenticated: boolean;

  title = 'app';
  isLoggedIn: boolean = false;
  regionDisplayName: string;
  employeeDisplayName: string;

  links = [];

  //Sidebar
  _opened: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private navUserAccessService: NavUserAccessService,
    private router: Router,
    activatedRoute: ActivatedRoute,
    public oktaAuth: OktaAuthService,
    private meta: Meta
  ) { }

  ngOnInit() {
    //Initialize all variables
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    this.authenticationService.loggedIn.subscribe(response => this.isLoggedIn = response);
    this.authenticationService.employeeDisplayName.subscribe(response => this.employeeDisplayName = response);

    //Make default route based on user type
    if (this.router.isActive('', true) == true) {
      if (this.currentUser.payrolladmin == true) {
        this.router.navigate(['/view-adjustment-records']);
      } else if (this.currentUser.payrollsuperadmin == true) {
        this.router.navigate(['/view-adjustment-records']);
      } else if (this.currentUser.canRequestNew == false) {
        this.router.navigate(['/view-adjustment-records']);
      } else {
        this.router.navigate(['/new-request']);
      }
    }

    //Define navigation links
    if (this.currentUser.payrolladmin == true && this.currentUser.payrollsuperadmin == true) {
      this.links = this.navUserAccessService.getNavigationSuperAdmin();
    } else if (this.currentUser.payrolladmin == true) {
      this.links = this.navUserAccessService.getNavigationAdmin();
    } else if (this.currentUser.payrollsuperadmin == true) {
      this.links = this.navUserAccessService.getNavigationSuperAdmin();
    } else if (this.currentUser.canRequestNew == false) {
      this.links = this.navUserAccessService.getNavigationAdmin();
    } else {
      this.links = this.navUserAccessService.getNavigation();
    }

  }

  private _toggleSidebar() {
    this._opened = !this._opened;
  }

  logOut() {
    if (environment.impersonation) {
      this.authenticationService.logout();
      this.router.navigate(['/login']);
    }

    if (!environment.impersonation) {
      this.authenticationService.logout();
      this.oktaAuth.logout('/')
    }

  }

  getDepth(outlet) {
    return outlet.activatedRouteData['depth'];
  }

}
